<template>
    <Forms
        ref="frmPermission"
        :title="'Buscar por Documento'"
        :showHelp="true"
        :showClearButtonIcon="true"
        :showSearchButtonIcon="true"
        :ShowFooterImbo="true"
        v-on:Clear="Clear"
        v-on:Search="Search"
    >
        <div>
<!--        <label class="label-search">Nome</label>
            <input v-model="search.nomeDocumento" class="form-control" placeholder="Insira o nome do documento" />
 -->
            <label  class="label-search" for="txtInsured">Nome</label>
            <autocomplete-z ref="documentoTypeahead"
             placeholder="Digite o nome funcionario"
             iconClass="fas fa-file-alt"
             :serializer="(documento) => documento.nome"
             :debounceLength="3"
             :formField="search.documentosObj"
             v-on:search="onSearchDocumento"
             v-on:changeCode="onSearchDocumento"
             :ShowCode="false"
            />

            <label class="label-search mt-3">Filtrar por </label>
            <select
                v-model="search.tipoPesquisa"
                v-on:input="cleanFilter"
                name="statusVistoria"
                class="form-control"
                id="exampleFormControlSelect2"
            >
                <option :value="0">Todos</option>
                <option :value="1">Geral</option>
                <option :value="2">Empreendimento</option>
                <option :value="3">Cliente</option>
            </select>

            <label  v-show="search.tipoPesquisa == 2" class="label-search mt-3">Empreendimento</label>
            <select v-show="search.tipoPesquisa == 2"
                v-model="search.empreendimentoId"
                name="statusVistoria"
                class="form-control"
                id="exampleFormControlSelect2"
            >
            <option v-for="document in documentsArray" :key="document.id" :value="document.id">{{document.nome}}</option>
            </select>
            <label v-show="search.tipoPesquisa == 3"  class="label-search mt-3"></label>
            <b-form-group v-show="search.tipoPesquisa == 3"  id="input-cpf" label="Digite o CPF do cliente:">
                <b-form-input
                id="customer-cpf-input"
                name="customer-cpf-input"
                v-model="customerCpf"
                v-validate="{ required: true, length: 14, numeric: false }"
                type="text"
                placeholder="___.___.___-__"
                required
                v-mask="['###.###.###-##']"
                ></b-form-input>
            </b-form-group>

            <label class="label-search mt-3">Data  Envio</label>
            <div class="mt-2 label-search" id="a-datapicker">Desde</div>
            <div id="datapicker-search-container">
                <datepicker
                class="datepicker"
                name="txtDateStart"
                v-model="search.dataInicio"
                :format="'dd/MM/yyyy'"
                :language="ptBR"
                :placeholder="$lang.Common.DatePlaceholder"
                :clear-button="true"
                :clear-button-icon="'fas fa-times'"
                :calendar-button="true"
                :calendar-button-icon="'fa fa-calendar'"
                :bootstrap-styling="true"
                :full-month-name="true"
                :use-utc="true"
                />
            </div>
            <div class="mt-2 label-search" id="a-datapicker">até</div>
            <div id="datapicker-search-container">
                <datepicker
                name="txtDateStart"
                class="datepicker"
                v-model="search.dataFim"
                :format="'dd/MM/yyyy'"
                :language="ptBR"
                :placeholder="$lang.Common.DatePlaceholder"
                :clear-button="true"
                :clear-button-icon="'fas fa-times'"
                :calendar-button="true"
                :calendar-button-icon="'fa fa-calendar'"
                :bootstrap-styling="true"
                :full-month-name="true"
                :use-utc="true"
                />
            </div>
        </div>
    </Forms>
</template>

<script>
import SearchCardDocument from './SearchCardDocument.js'
export default SearchCardDocument
</script>

<style scoped>
#datapicker-search-container{
    width: 100%;
    display: flex;
    justify-content: center;
    gap: 15px;
}
.label-search{
    font-weight: 700;
    color: #666;
    font-size: 14px;
    margin-bottom: 5px;
    padding-bottom: 0;
    font-family: Segoe UI;
}
</style>



// WEBPACK FOOTER //
// src/views/private/documentsManagement/components/SearchCardDocument/SearchCardDocument.vue